import React, { useState, useEffect } from 'react';
import { focusHandling } from 'cruip-js-toolkit';
import Customer from './CustomersTableItem';

import Image01 from '../../images/user-40-01.jpg';
import Image02 from '../../images/user-40-02.jpg';
import Image03 from '../../images/user-40-03.jpg';
import Image04 from '../../images/user-40-04.jpg';
import Image05 from '../../images/user-40-05.jpg';
import Image06 from '../../images/user-40-06.jpg';
import Image07 from '../../images/user-40-07.jpg';
import Image08 from '../../images/user-40-08.jpg';
import Image09 from '../../images/user-40-09.jpg';
import Image10 from '../../images/user-40-10.jpg';

function CustomersTable({
  selectedItems
}) {

  const getCustomers = async () => {
    try{
      const res = await fetch('https://sheet.best/api/sheets/b3319fcd-6731-460f-ae55-48b8f7bb3761')
      const data = await res.json();
      setData(data)
    }catch (error) {
      console.log(error)
    }
  }

  const customers = [
    {
      id: '0',
      image: Image01,
      name: 'Patricia Semklo',
      email: 'patricia.semklo@app.com',
      location: '✅ INTERESADO',
      orders: '24',
      lastOrder: '#123567',
      spent: '$2,890.66',
      refunds: '-'
    },
    {
      id: '1',
      image: Image02,
      name: 'Dominik Lamakani',
      email: 'dominik.lamakani@gmail.com',
      location: '❌ NO LE INTERESA',
      orders: '77',
      lastOrder: '#779912',
      spent: '$14,767.04',
      refunds: '4'
    },
    {
      id: '2',
      image: Image03,
      name: 'Ivan Mesaros',
      email: 'imivanmes@gmail.com',
      location: '🔵 ZOOM',
      orders: '44',
      lastOrder: '#889924',
      spent: '$4,996.00',
      refunds: '1'
    },
    {
      id: '3',
      image: Image04,
      name: 'Maria Martinez',
      email: 'martinezhome@gmail.com',
      location: '📬 Buzon de Voz',
      orders: '29',
      lastOrder: '#897726',
      spent: '$3,220.66',
      refunds: '2'
    },
    {
      id: '4',
      image: Image05,
      name: 'Vicky Jung',
      email: 'itsvicky@contact.com',
      location: '📧 MAIL',
      orders: '22',
      lastOrder: '#123567',
      spent: '$2,890.66',
      refunds: '-'
    },
    {
      id: '5',
      image: Image06,
      name: 'Tisho Yanchev',
      email: 'tisho.y@kurlytech.com',
      location: '✅ INTERESADO',
      orders: '14',
      lastOrder: '#896644',
      spent: '$1,649.99',
      refunds: '1'
    },
    {
      id: '6',
      image: Image07,
      name: 'James Cameron',
      email: 'james.ceo@james.tech',
      location: '🔵 ZOOM',
      orders: '34',
      lastOrder: '#136988',
      spent: '$3,569.87',
      refunds: '2'
    },
    {
      id: '7',
      image: Image08,
      name: 'Haruki Masuno',
      email: 'haruki@supermail.jp',
      location: '❌ NO LE INTERESA',
      orders: '112',
      lastOrder: '#442206',
      spent: '$19,246.07',
      refunds: '6'
    },
    {
      id: '8',
      image: Image09,
      name: 'Joe Huang',
      email: 'joehuang@hotmail.com',
      location: '✅ INTERESADO',
      orders: '64',
      lastOrder: '#764321',
      spent: '$12,276.92',
      refunds: '-'
    },
    {
      id: '9',
      image: Image10,
      name: 'Carolyn McNeail',
      email: 'carolynlove@gmail.com',
      location: '✅ INTERESADO',
      orders: '19',
      lastOrder: '#908764',
      spent: '$1,289.97',
      refunds: '2'
    }
  ];

  const [selectAll, setSelectAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setData] = useState();

  useEffect(() => {
    getCustomers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    focusHandling('outline');
  }, [list]);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setIsCheck(list.map(li => li.id));
    if (selectAll) {
      setIsCheck([]);
    }
  };

  const handleClick = e => {
    const { id, checked } = e.target;
    setSelectAll(false);
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter(item => item !== id));
    }
  };

  useEffect(() => {
    selectedItems(isCheck);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheck]);

  return (
    <div className="bg-white shadow-lg rounded-sm border border-gray-200 relative">
      <header className="px-5 py-4">
        <h2 className="font-semibold text-gray-800">Mis clientes <span className="text-gray-400 font-medium">248</span></h2>
      </header>
      <div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full">
            {/* Table header */}
            <thead className="text-xs font-semibold uppercase text-gray-500 bg-gray-50 border-t border-b border-gray-200">
              <tr>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                  <div className="flex items-center">
                    <label className="inline-flex">
                      <span className="sr-only">Seleccionar todos</span>
                      <input className="form-checkbox" type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                    </label>
                  </div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Nombre</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Contacto</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Estado</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold">Estado Whatsapp</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Hora de Contacto</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold text-left">Desgloce</div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="font-semibold">Fecha</div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm divide-y divide-gray-200">
              {
                list?.map(customer => {
                  return (
                    <Customer
                      key={customer.Contact_ID}
                      id={customer.Contact_ID}
                      name={customer.Nombre + ' ' + customer.Apellido}
                      email={customer.Correo}
                      location={customer.Estado_Lead}
                      orders={customer.Status_Whatsapp}
                      lastOrder={customer.Horario_contacto}
                      spent={customer.Desgloce}
                      refunds={customer.Fecha}
                      handleClick={handleClick}
                      isChecked={isCheck.includes(customer.Contact_ID)}
                    />
                  )
                })
              }
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
}

export default CustomersTable;
